/* Adds an optional extra product to the cart alongside the item being bought.

   The add-on is a real product rather than a variant option, so an abaya with
   seven colours and three sizes stays at 21 variants instead of 42.

   Dawn's product form submits over AJAX and refreshes the cart drawer from the
   response. So the add-on is added first, quietly, and then Dawn's own submit
   runs as normal -- its refresh then shows both lines. If the add-on request
   fails, the abaya is still added; the shopper is never blocked by the extra. */
class ProductAddon extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('[data-addon-checkbox]');
    this.variantId = this.dataset.variantId;
    this.form = this.closest('.product')?.querySelector('form[action*="/cart/add"]');
    if (!this.checkbox || !this.variantId || !this.form) return;

    this.pending = false;
    this.form.addEventListener('submit', this.onSubmit.bind(this), true);
  }

  onSubmit(event) {
    if (!this.checkbox.checked || this.pending) return;

    // Hold Dawn's handler while the add-on goes in, then let it run untouched.
    event.preventDefault();
    event.stopImmediatePropagation();
    this.pending = true;
    this.setBusy(true);

    const body = JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1 }] });

    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    })
      .catch(() => {
        /* Adding the abaya matters more than the add-on. Carry on either way. */
      })
      .finally(() => {
        this.setBusy(false);
        this.checkbox.checked = false;
        this.form.requestSubmit
          ? this.form.requestSubmit()
          : this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        // Released only after the resubmitted event has been handled.
        setTimeout(() => {
          this.pending = false;
        }, 0);
      });
  }

  setBusy(state) {
    this.toggleAttribute('busy', state);
    this.checkbox.disabled = state;
  }
}

if (!customElements.get('product-addon')) {
  customElements.define('product-addon', ProductAddon);
}
